import List from '../../../features/customer/question/components/List';
import {
    PageLayout,
    ContentTemplate,
} from '../../../features/common/components/layout';

const QuestionPage = ({ history }) => {
    return (
        <PageLayout>
            <ContentTemplate>
                <List history={history} />
            </ContentTemplate>
        </PageLayout>
    );
};

export default QuestionPage;
